import { render, staticRenderFns } from "./gradeDetail.vue?vue&type=template&id=4bed11d5&scoped=true"
import script from "./gradeDetail.vue?vue&type=script&lang=js"
export * from "./gradeDetail.vue?vue&type=script&lang=js"
import style0 from "./gradeDetail.vue?vue&type=style&index=0&id=4bed11d5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bed11d5",
  null
  
)

export default component.exports